import Vue from 'vue';
import Router from "vue-router";

Vue.use(Router);

const routes = [
    {
        path: "/",
        component: () => import("./views/HrAuditNew.vue"),
    },
    {
        path: "/:id/",
        name: "report",
        component: () => import("./views/HrAudit"),
        props: true
    },
];

const router = new Router({
    base: '/',
    mode: "history",
    routes
});

export default router;
